import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface LanguageSwitcherProps {
  className?: string;
  showLabel?: boolean;
  variant?: 'default' | 'compact' | 'icon-only';
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  className = '', 
  showLabel = true,
  variant = 'default'
}) => {
  const { language, setLanguage, isRTL } = useLanguage();

  const handleLanguageChange = (newLanguage: 'ar' | 'en') => {
    setLanguage(newLanguage);
  };

  if (variant === 'icon-only') {
    return (
      <div className={`relative ${className}`}>
        <button
          onClick={() => handleLanguageChange(language === 'ar' ? 'en' : 'ar')}
          className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 light:bg-gray-100 light:hover:bg-gray-200 transition-colors"
          title={language === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
        >
          <Globe className="w-5 h-5" />
        </button>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className={`flex items-center gap-1 bg-gray-800 dark:bg-gray-800 light:bg-gray-100 rounded-lg p-1 ${className}`}>
        <button
          onClick={() => handleLanguageChange('ar')}
          className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
            language === 'ar'
              ? 'bg-blue-500 text-white'
              : 'text-gray-400 hover:text-white dark:text-gray-400 dark:hover:text-white light:text-gray-600 light:hover:text-gray-900'
          }`}
        >
          ع
        </button>
        <button
          onClick={() => handleLanguageChange('en')}
          className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
            language === 'en'
              ? 'bg-blue-500 text-white'
              : 'text-gray-400 hover:text-white dark:text-gray-400 dark:hover:text-white light:text-gray-600 light:hover:text-gray-900'
          }`}
        >
          EN
        </button>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 bg-gray-800 dark:bg-gray-800 light:bg-gray-100 rounded-lg px-3 py-2 ${className}`}>
      {showLabel && <Globe className="w-4 h-4 text-gray-400" />}
      <select 
        value={language}
        onChange={(e) => handleLanguageChange(e.target.value as 'ar' | 'en')}
        className="bg-transparent text-sm border-none outline-none cursor-pointer text-white dark:text-white light:text-gray-900"
        style={{ direction: 'ltr' }} // Always LTR for language selector
      >
        <option value="ar">العربية</option>
        <option value="en">English</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;